import type { NextApiRequest } from 'next'
import {
  type CreateOrderRequest,
  type Language,
  type NshiftCreateSessionRequest,
  type NshiftCreateSessionResponse,
  type OldProductDTO
} from 'ecosystem'
import { computeFromStoreFrontOrderLines, nshiftApi } from 'api'
import { calculateOrderTotalWeight, getFullLocale } from 'shared-utils'
import * as productsApi from 'api/storefront-api/productsEndpoint'
import { type ShippingProviderOpts } from '../shippingProviders/types'

export const nshiftShippingProvider = async (
  req: NextApiRequest,
  opts: ShippingProviderOpts
): Promise<NshiftCreateSessionResponse> => {
  const locale = (req.cookies.NEXT_LOCALE || opts.locale || 'sv') as Language
  const { items, cartDiscountCode }: CreateOrderRequest = JSON.parse(req.body)

  const fullProducts: OldProductDTO[] = await (async () => {
    const productIds = items?.map((item) => item.product.id) ?? []

    if (!productIds?.length) {
      return []
    }

    const productsResponse = await productsApi.listProductsFull(
      {
        productIds,
        ...(opts.customerId ? { customerId: opts.customerId } : {})
      },
      {
        size: productIds.length
      }
    )

    return productsResponse.content
  })()

  if (fullProducts.length !== items?.length) {
    throw new Error('Products are not found')
  }
  const { orderAmount } = computeFromStoreFrontOrderLines(items, cartDiscountCode)

  const { totalWeight, extendedItems } = calculateOrderTotalWeight(items, fullProducts)

  const payload: NshiftCreateSessionRequest = {
    currencyCode: opts.currencyCode,
    languageCode: locale,
    localeId: getFullLocale(locale),
    totalPrice: orderAmount,
    packages: [
      {
        weightKg: totalWeight,
        articles: extendedItems.map((item) => ({
          articleNo: item.product.articleNumber,
          quantity: item.quantity,
          weightKg: item.weight
        }))
      }
    ]
  }

  return nshiftApi.checkout.createSession(payload)
}
